import { render } from "./Hour.vue?vue&type=template&id=2103869e&scoped=true"
const script = {}

import "./Hour.vue?vue&type=style&index=0&id=2103869e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\pc\\Documents\\projets\\school_app_front_novation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2103869e"]])

export default __exports__